<div class="entry-shell container">
  <nav class="entry-nav">
    <app-breadcrumbs></app-breadcrumbs>
    <div [class]="'prev-next' + (entries.length <= 1 ? ' disabled' : '')">
      <a class="prev" (click)="navEntry(-1)"><img src="../../../assets/images/prev-blk-001.svg" width="10" alt="Previous Post">&nbsp;&nbsp;prev</a> 
      <a class="next" (click)="navEntry(1)">next&nbsp;&nbsp;<img src="../../../assets/images/next-blk-001.svg" width="10" alt="Next Entry"></a>
    </div>
  </nav>
  <article class="entry">
    <header class="entry-header">
			<div class="thumb" [style.background-image]="entry?.fields.thumbImage ? 'url(' + entry?.fields.thumbImage.fields.file.url + ')' : 'url(' + placeholderImg + ')'">
				<div class="blur"></div>
        <div class="corner"></div>
			</div>
      <h1>{{ entry?.fields.title }}</h1>
      <div class="meta">
        <p class="date">
          Published on: {{ 
            formatDate(entry?.fields.date || entry?.sys.firstPublishedAt || entry?.sys.createdAt)
          }}
          <span class="divider"></span> 
          Updated on: {{ 
            formatDate(entry?.sys.publishedAt || entry?.sys.updatedAt)
          }}
        </p>
      </div>
    </header>
    <section #entryContent class="entry-content" [innerHTML]="entry?.fields.description"></section>
    <footer class="entry-footer">
      <div *ngIf="entry?.fields.categories || entry?.metadata.tags.length" class="meta">
        <div class="border"></div>
        <ul *ngIf="entry?.fields.categories" class="entry-cats">
          <h3>Categories</h3>
          <li *ngFor="let cat of entry?.fields.categories">
            {{ cat }}<br />
          </li>
        </ul>
        <ul *ngIf="entry?.metadata.tags.length" class="entry-tags">
          <h3>Tags</h3>
          <li *ngFor="let tag of entry?.metadata.tags">
            {{ contentService.tagIDtoName(tag.sys.id) }}
          </li>
        </ul>
      </div>
      <nav class="footer-nav">
        <div class="border"></div>
        <div [class]="'prev-next' + (entries.length <= 1 ? ' disabled' : '')">
          <a class="prev" (click)="navEntry(-1)"><img src="../../../assets/images/prev-blk-001.svg" width="10" alt="Previous post">&nbsp;&nbsp;<span>Previous post</span></a> 
          <span class="divider"></span>
          <a class="next" (click)="navEntry(1)"><span>Next post</span>&nbsp;&nbsp;<img src="../../../assets/images/next-blk-001.svg" width="10" alt="Next post"></a>
          </div>
        <a class="return-home textlink" [href]="'/blog'" [attr.data-content]="'Blog Post Return Home'" (click)="analyticsService.trackInput($event);">Return to blog home</a>
      </nav>
      <app-related-entries [entries]="relatedEntries" (openEntry)="openEntry($event)"></app-related-entries>
    </footer>
  </article>
  <app-newsletter-banner></app-newsletter-banner>
  <app-social 
    heading="Let&rsquo;s make it official"
    subheading="Follow me on these platforms:"
    enabled="linkedin, twitter, behance"
  >
  </app-social>
  <div class="border"></div>
</div>
<nh-footer></nh-footer>
